require("../styles/_Common.scss");

// const abiDecoder = require('abi-decoder'); // NodeJS ES6 doesn't Uglify

import React from "react";

class ABIchecker extends React.Component {
    
    constructor(props) {
        super(props);
        
        this.state = {
        };
        
        this.tradesmanABI = 
[{"constant":true,"inputs":[],"name":"name","outputs":[{"name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_spender","type":"address"},{"name":"_value","type":"uint256"}],"name":"approve","outputs":[{"name":"success","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"totalSupply","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_from","type":"address"},{"name":"_to","type":"address"},{"name":"_value","type":"uint256"}],"name":"transferFrom","outputs":[{"name":"success","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"buyMultiplier","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"decimals","outputs":[{"name":"","type":"uint8"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_value","type":"uint256"}],"name":"burn","outputs":[{"name":"success","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"sellPrice","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_to","type":"address"},{"name":"_value","type":"uint256"}],"name":"tokenTransfer","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"name":"","type":"address"}],"name":"balanceOf","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_from","type":"address"},{"name":"_value","type":"uint256"}],"name":"burnFrom","outputs":[{"name":"success","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"buyPrice","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_to","type":"address"},{"name":"_value","type":"uint256"},{"name":"_data","type":"bytes"}],"name":"genericTransfer","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"owner","outputs":[{"name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"symbol","outputs":[{"name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_to","type":"address"},{"name":"_value","type":"uint256"}],"name":"etherTransfer","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[],"name":"buy","outputs":[],"payable":true,"stateMutability":"payable","type":"function"},{"constant":false,"inputs":[{"name":"_to","type":"address"},{"name":"_value","type":"uint256"}],"name":"transfer","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"name":"","type":"address"}],"name":"frozenAccount","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_spender","type":"address"},{"name":"_value","type":"uint256"},{"name":"_extraData","type":"bytes"}],"name":"approveAndCall","outputs":[{"name":"success","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"newSellPrice","type":"uint256"},{"name":"newSellMultiplier","type":"uint256"},{"name":"newBuyPrice","type":"uint256"},{"name":"newBuyMultiplier","type":"uint256"}],"name":"setPrices","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"name":"","type":"address"},{"name":"","type":"address"}],"name":"allowance","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"amount","type":"uint256"}],"name":"sell","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"target","type":"address"},{"name":"freeze","type":"bool"}],"name":"freezeAccount","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"sellMultiplier","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"inputs":[{"name":"initialSupply","type":"uint256"},{"name":"tokenName","type":"string"},{"name":"tokenSymbol","type":"string"}],"payable":false,"stateMutability":"nonpayable","type":"constructor"},{"payable":true,"stateMutability":"payable","type":"fallback"},{"anonymous":false,"inputs":[{"indexed":false,"name":"target","type":"address"},{"indexed":false,"name":"frozen","type":"bool"}],"name":"FrozenFunds","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"from","type":"address"},{"indexed":true,"name":"to","type":"address"},{"indexed":false,"name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"from","type":"address"},{"indexed":false,"name":"value","type":"uint256"}],"name":"Burn","type":"event"}];
        
        this.handleSubmit = this.handleSubmit.bind(this);
    }
    
    componentWillMount() {
        // could also do inline in base_admin.html to keep out of public webpack.js
        
        /*
        const scr = document.createElement("script");

        scr.src = "/js/abi-decoder.js";
        scr.async = false;

        document.head.appendChild(scr);
        */
    }

    handleSubmit() {
        abiDecoder.addABI(this.tradesmanABI);
        
        var code = this.refs.code.value;
        
        this.refs.data_encoded.innerText = code;
        this.refs.data_decoded.innerText = JSON.stringify( abiDecoder.decodeMethod( code ) );
    }
    
    render() {    

                                    
        return (
            <div className="container center_this max_width_760">
            
                <form   ref     = "theForm"  
                    onSubmit = {this.handleSubmit}
                > 
                    <div className="form_td">
                        <div className ="inline_block">
                            code: 
                        </div>
                        <input ref="code" type="text" className = "form_input ht_175" />
        
                    </div>
                </form>
                            
                <input  type            = "button" 
                        ref             = "registerButton" 
                        className       = "button_sm form_submit" 
                        onClick         = { this.handleSubmit } 
                        defaultValue    = "decode"
                />
                      
                      
                            
                <div className = "margin_30_0_0 align_left">
                    <h4>Encoded Data:</h4>
                    <div ref = "data_encoded" />
                </div>
                
                <div className = "margin_30_0_0 align_left">
                    <h4>Decoded:</h4>
                    <div ref = "data_decoded" />
                </div>
                            
                
                
               
                <div className = "m_top_30_pct align_left">
                    <h3>Here are some examples:</h3>
                        
                        <div>
                            <div className = "inline_block padding_0_8">
                                0xa6f2ae3a
                            </div>
                            <div className = "inline_block">
                                {`[{name: "buy", params: []}]`}
                            </div>
                        </div>
                        
                        <div>
                            <div className = "inline_block padding_0_8">
                                0xe4849b32
                            </div>
                            <div className = "inline_block">
                                {`[{name: "sell", params: [{name: "amount", value: "0", type: "uint256"}]}]`}
                            </div>
                        </div>
                        
                        <div>
                            <div className = "inline_block padding_0_8">
                                0xe4849b32000000000000000000000000000000000000000000000000016345785d8a0000
                            </div>
                            <div className = "inline_block">
                                
                            </div>
                        </div>
                        
                        <div>
                            <div className = "inline_block padding_0_8">
                                0x9c250dd8000000000000000000000000c056597f7c83e03d87e788c99f6c10f62c61bbe7000000000000000000000000000000000000000000000000016345785d89ff86
                            </div>
                            <div className = "inline_block">
                                
                            </div>
                        </div>
                        
                        <div>
                            <div className = "inline_block padding_0_8">
                                0x9c250dd8000000000000000000000000c056597f7c83e03d87e788c99f6c10f62c61bbe70000000000000000000000000000000000000000000000000853a0d2313c0000
                            </div>
                            <div className = "inline_block">
                                
                            </div>
                        </div>
                        
                        <div>
                            <div className = "inline_block padding_0_8">
                                0000000000000000000000000000000000000000003e09de2596099e2afffc18
                            </div>
                            <div className = "inline_block">
                                
                            </div>
                        </div>
                        
                        <div>
                            <div className = "inline_block padding_0_8">
                                0x23b872dd
                            </div>
                            <div className = "inline_block">
                                            {`{"name":"transferFrom","params":[{"name":"_from","value":"0x","type":"address"},{"name":"_to","value":"0x","type":"address"},{"name":"_value","value":"0","type":"uint256"}]}`}
                            </div>
                        </div>
                        
                        <div>
                            <div className = "inline_block padding_0_8">
                                0xe4849b3200000000000000000000000000000000000000000000000000000000000003e8
                            </div>
                            <div className = "inline_block">
                                {`{"name":"sell","params":[{"name":"amount","value":"1000","type":"uint256"}]}`}
                            </div>
                        </div>
                        
                        <div>
                            <div className = "inline_block padding_0_8">
                                0xe4849b3200000000000000000000000000000000000000000000000000000000000000c8
                            </div>
                            <div className = "inline_block">
                                {`{name: "sell", params: [{name: "amount", value: "200", type: "uint256"}]}`}
                            </div>
                        </div>
                        
                        <div className = "margin_30_0_0">
                        View hex values at: <a href="http://hextodecimal.com/index.php?hex=C8">http://hextodecimal.com/index.php?hex=C8</a>
                        </div>
                    </div>
            </div>
        )
    }
}


export default ABIchecker;
